// Copyright 2026 Hardfin, Inc.
import {
  FulfillmentOrderPhase,
  FulfillmentOrderSubstatus,
} from '@/constants/fulfillment-order-line-item-status';
import {
  AddTaskOutlined,
  Contrast,
  EditOutlined,
  KeyboardTabOutlined,
  LocalShippingOutlined,
  PendingOutlined,
} from '@/constants/hardfin-standard-icons';
import { ReactElement } from 'react';

/**
 * Icon components for each base status (phase).
 */
const FO_BASE_STATUS_ICONS: Record<FulfillmentOrderPhase, () => ReactElement> =
  {
    draft: () => <EditOutlined fontSize="small" />,
    open: () => <PendingOutlined fontSize="small" />,
    shipped: () => <LocalShippingOutlined fontSize="small" />,
    delivered: () => <KeyboardTabOutlined fontSize="small" />,
  };

/**
 * Get the appropriate icon for a status.
 * Partial and overage modifiers override the base icon.
 */
export function getStatusIcon(
  base: FulfillmentOrderPhase,
  modifier: FulfillmentOrderSubstatus | null
): ReactElement {
  if (modifier === 'partial') {
    return <Contrast fontSize="small" />;
  }
  if (modifier === 'overage') {
    return <AddTaskOutlined fontSize="small" />;
  }
  return FO_BASE_STATUS_ICONS[base]();
}
